import { Menu } from "@headlessui/react";
import { isBefore, isSameMonth } from "date-fns";
import { enUS } from "date-fns/locale";
import useStore from "../hooks/useStore";

const MonthsDialog = () => {
  const selectedMonth = useStore((state) => state.selectedMonth);
  const selectedYear = useStore((state) => state.selectedYear);
  const setSelectedMonth = useStore((state) => state.setSelectedMonth);

  const renderMonths = () => {
    return [...Array(12)].map((_, i) => {
      const currentDate = new Date();
      const prevMonth = new Date(selectedYear.value, i, 1);

      const disabled =
        isBefore(prevMonth, currentDate) &&
        !isSameMonth(prevMonth, currentDate);

      return (
        <Menu.Item key={i}>
          <span
            onClick={() => setSelectedMonth(i)}
            className={`tw-select-none tw-flex tw-justify-center tw-rounded-md tw-py-1 ${
              selectedMonth.value === i
                ? "tw-bg-tr tw-text-white"
                : "tw-bg-white tw-text-tr-date hover:tw-bg-tr-date/10"
            } ${
              disabled
                ? "tw-opacity-30 tw-pointer-events-none"
                : "tw-cursor-pointer"
            }`}
          >
            {enUS.localize?.month(i, { width: "abbreviated" })}
          </span>
        </Menu.Item>
      );
    });
  };
  return (
    <Menu>
      <Menu.Button className="tw-flex tw-items-center tw-space-x-2">
        <span className="uppercased-heading tw-select-none">
          {selectedMonth.formatted} {selectedYear.formatted}
        </span>
        <svg
          className="tw-w-6 tw-h-6 tw-text-white tw-cursor-pointer"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </Menu.Button>
      <Menu.Items className="tw-bg-white tw-px-4 tw-py-6 tw-border tw-shadow-xl tw-w-80 tw-rounded-md tw-absolute tw-origin-center tw-top-full tw-left-1/2 tw-transform tw--translate-y-[10px] tw--translate-x-1/2 tw-grid tw-grid-cols-3 tw-gap-4">
        {renderMonths()}
      </Menu.Items>
    </Menu>
  );
};

export default MonthsDialog;
